"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelativeCursorPositionObserver = void 0;
var RelativeCursorPositionObserver = /*#__PURE__*/function () {
  function RelativeCursorPositionObserver() {
    _classCallCheck(this, RelativeCursorPositionObserver);
  }
  _createClass(RelativeCursorPositionObserver, [{
    key: "subject",
    get: function get() {
      return this._subject;
    },
    set: function set(value) {
      this._subject = value;
    }
  }, {
    key: "documentRelativeElementOffset",
    get: function get() {
      if (!this._subject) {
        throw new Error('Not yet initialized. Subject is not set');
      }
      if (!this.elementOffset) {
        this.elementOffset = this.getDocumentRelativeElementOffset(this._subject);
      }
      return this.elementOffset;
    }
  }, {
    key: "getDocumentRelativeElementOffset",
    value: function getDocumentRelativeElementOffset(el) {
      var rootEl = this.getRootOfEl(el);
      var _rootEl$getBoundingCl = rootEl.getBoundingClientRect(),
        docLeft = _rootEl$getBoundingCl.left,
        docTop = _rootEl$getBoundingCl.top;
      var _el$getBoundingClient = el.getBoundingClientRect(),
        elLeft = _el$getBoundingClient.left,
        elTop = _el$getBoundingClient.top;
      return {
        x: Math.abs(docLeft) + elLeft,
        y: Math.abs(docTop) + elTop
      };
    }
  }, {
    key: "getRootOfEl",
    value: function getRootOfEl(el) {
      if (el.parentElement) {
        return this.getRootOfEl(el.parentElement);
      }
      return el;
    }
  }, {
    key: "getComputedElementRelativeCursorPosition",
    value: function getComputedElementRelativeCursorPosition(event, documentRelativeElementOffset) {
      var position = this.getDocumentRelativeCursorPosition(event);
      var cursorX = position.x,
        cursorY = position.y;
      var offsetX = documentRelativeElementOffset.x,
        offsetY = documentRelativeElementOffset.y;
      return {
        x: Math.round(cursorX - offsetX),
        y: Math.round(cursorY - offsetY)
      };
    }
  }, {
    key: "getDocumentRelativeCursorPosition",
    value: function getDocumentRelativeCursorPosition(event) {
      return {
        x: event.pageX,
        y: event.pageY
      };
    }
  }, {
    key: "getCursorPosition",
    value: function getCursorPosition(event) {
      return this.getComputedElementRelativeCursorPosition(event, this.documentRelativeElementOffset);
    }
  }]);
  return RelativeCursorPositionObserver;
}();
exports.RelativeCursorPositionObserver = RelativeCursorPositionObserver;